import * as React from 'react';

import styles from './CatalogFirstView.scss';
import { genPublicUrl } from 'libs/image';
import { useCatalogLayoutContext } from 'components/catalogs/layouts/CatalogLayout/CatalogLayout';

export const CatalogFirstView = (): JSX.Element | null => {
  const { catalog, hasError } = useCatalogLayoutContext();
  const imageUrl = catalog?.topImageUrl?.trim() ?? '';
  const isLoading = !catalog && !hasError;

  if (!imageUrl && !isLoading) {
    return null;
  }

  return (
    <section
      className={styles.fv}
      aria-label="カタログのトップ画像"
      aria-busy={isLoading}
    >
      {imageUrl ? (
        <img
          className={styles.image}
          src={genPublicUrl(imageUrl, 1920)}
          alt=""
          decoding="async"
          loading="eager"
        />
      ) : (
        <div
          className={styles.placeholder}
          aria-hidden="true"
        />
      )}
    </section>
  );
};
